import { render, staticRenderFns } from "./QuickOrderForm.vue?vue&type=template&id=22acf456&scoped=true&"
import script from "./QuickOrderForm.vue?vue&type=script&lang=js&"
export * from "./QuickOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22acf456",
  null
  
)

export default component.exports